import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_EMPLOYMENTS_SUCCESS,
  UPDATE_DECLARATION_SUCCESS,
  UPDATE_REVIEW_SUCCESS,
} from './../actions/types'

const redirectUrl = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.redirectUrl

    case LOAN_APPLICATION_UPDATE_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_EMPLOYMENTS_SUCCESS:
    case UPDATE_DECLARATION_SUCCESS:
    case UPDATE_REVIEW_SUCCESS:
      return payload.redirectUrl
    default:
      return state
  }
}

export const getRedirectUrlReference = (state) => (state)

export default redirectUrl;
